import React from "react";

import bg from "../../assets/Lilac Waves.mp4";
import poster from "../../assets/hero-poster.jpg";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import Logo from "@components/Logo";
import LangChanger from "@layout/LangChanger";
import { LucideCircleUserRound } from "lucide-react";
import { useLocation } from "react-router-dom";
import Hero from "./Hero";

function Main({ openModal }) {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Hero videoSrc={bg} poster={poster}>
      <div className="px-2 px-md-10">
        <Row className="py-5 ">
        {/* Logo */}
        <Col xs={4} xl={3}>
          <Logo isWhite size="sm"/>
        </Col>

        {/* Right side */}
        <Col xs={8} xl={9}>
          <div className="d-flex justify-content-end align-items-center gap-4 text-white">
            
            <LangChanger location={location} t={t} />

            {/* Desktop buttons */}
            <button
              className="d-none d-lg-inline-block bg-blue text-white py-2 px-4 rounded-3 border border-white"
              onClick={() => openModal("in")}
              aria-label="Login"
            >
              {t("log_in")}
            </button>

            <button
              className="d-none d-lg-inline-block bg-blue text-white bg-opacity-50 py-2 px-4 rounded-3"
              onClick={() => openModal("up")}
              aria-label="Register"
            >
              {t("register")}
            </button>

            {/* Mobile button */}
            <button
              className="d-inline-block d-lg-none bg-transparent border-0 text-white"
              onClick={() => openModal("in")}
              aria-label="User menu"
            >
              <LucideCircleUserRound size={23} />
            </button>
          </div>
        </Col>
      </Row>
      </div>
      <div className="d-flex align-items-center justify-content-center text-center h-100">
         <div className="d-inline-block text-white fw-bold text-uppercase fs-6 mt-4 glare-text px-4 py-2 rounded-pill border-1 border border-white" style={{
                      backgroundColor: "rgba(255, 255, 255, 0.1)", // 10% opacity
                      backdropFilter: "blur(10px)",
                      WebkitBackdropFilter: "blur(10px)", // Safari support
                      color: "#ffffff", // pure white text
                     
                      borderColor: "rgba(255, 255, 255, 0.7)" 
                    }}>
                  {t("l'intelligence au-delà du ")}<span className="element-slideLeftAnimation">{t("réel")}</span>
                </div>
      </div>
    </Hero>
  );
}

export default Main;